import { MessagingHelper } from "../helpers/MessagingHelper";
import { APIService } from "./APIService";

export class DownloadService {
    async DownloadFile(importOption: string): Promise<any> { 
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Download/DownloadFile?importOption=${encodeURIComponent(importOption)}`,
                null,
                {
                    headers: {
                        Accept: "application/octet-stream",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                    responseType: "blob", 
                }
            );
            return response;
        } catch (error) {
            return new MessagingHelper<null>(false, "Erro ao importar o ficheiro", null);
        }
    }
}
